import React from "react";
import {
  Grid,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { PhotoUploaderStyles } from "./PhotoUploaderStyles";
import PhotosUploadUtil, { truncateFileName } from "./PhotosUploadUtil";
import CloseIcon from "@material-ui/icons/Close";
import "./photosstyle.css";
import {
  FILE_SIZE_ERROR,
  FILE_TYPE_ERROR,
  MAX_ALLOWED_PHOTO_SIZE_IN_MB,
} from "../constants/GlobalConstants";

export const Damages = (props: any) => {
  const classes = PhotoUploaderStyles();
  const [imgLSDPreview, setImgLSDPreview] = React.useState(undefined);
  const [imgCDPreview, setImgCDPreview] = React.useState(undefined);
  const [imgRSDPreview, setImgRSDPreview] = React.useState(undefined);
  const [imgLSDPreviewName, setImgLSDPreviewName] = React.useState(undefined);
  const [imgCDPreviewName, setImgCDPreviewName] = React.useState(undefined);
  const [imgRSDPreviewName, setImgRSDPreviewName] = React.useState(undefined);

  const [lsdError, setLSDError] = React.useState(undefined);
  const [cdError, setCDError] = React.useState(undefined);
  const [rsdError, setRSDError] = React.useState(undefined);

  const [lsdErrorMessage, setLSDErrorMessage] = React.useState(FILE_SIZE_ERROR);
  const [cdErrorMessage, setCDErrorMessage] = React.useState(FILE_SIZE_ERROR);
  const [rsdErrorMessage, setRSDErrorMessage] = React.useState(FILE_SIZE_ERROR);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const handleEvent = (e) => {
    console.log(e.target.id);
    if (e.target.files.length > 1) {
      // setError("Error");
    } else {
      let fileInfoArr = [];
      const selected = e.target.files[0];
      let selectedFile = e.target.files[0];
      const selectID = e.target.id;
      console.log(selected.name);
      if (selectID === "drop_lsd_bt") {
        setLSDError(false);
      } else if (selectID === "drop_cd_bt") {
        setCDError(false);
      } else if (selectID === "drop_rsd_bt") {
        setRSDError(false);
      }
      let selectedFileSize = selected.size / 1024 / 1024; // in MB
      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      let image = new Image();
      if (
        selected &&
        ALLOWED_TYPES.includes(selected.type) &&
        selectedFileSize <= MAX_ALLOWED_PHOTO_SIZE_IN_MB
      ) {
        console.log("Selected");
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          console.log("File Width " + selected.naturalWidth);
          console.log("File Height " + selected.naturalHeight);
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            if (selectID === "drop_lsd_bt") {
              setImgLSDPreview(reader.result);
              selectedFile.imageLabel = "Damage - Left Angle";
              selectedFile.additionalDescription = "Damage - Left Angle";
              selectedFile.imageDisplayFileName = selected.name;
              setImgLSDPreviewName(selected.name);
            } else if (selectID === "drop_cd_bt") {
              setImgCDPreview(reader.result);
              selectedFile.imageLabel = "Damage - Center";
              selectedFile.additionalDescription = "Damage - Center";
              selectedFile.imageDisplayFileName = selected.name;
              setImgCDPreviewName(selected.name);
            } else if (selectID === "drop_rsd_bt") {
              setImgRSDPreview(reader.result);
              selectedFile.imageLabel = "Damage - Right Angle";
              selectedFile.additionalDescription = "Damage - Right Angle";
              selectedFile.imageDisplayFileName = selected.name;
              setImgRSDPreviewName(selected.name);
            }
            fileInfoArr.push(selectedFile);
            props.updatePhotoFile(selectedFile);
            console.log(fileInfoArr.length);
          };
        };

        reader.readAsDataURL(selected);
      } else if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
        console.log("Error: File size more than 10 MB");
        if (selectID === "drop_lsd_bt") {
          setLSDError(true);
          setLSDErrorMessage(FILE_SIZE_ERROR);
        } else if (selectID === "drop_cd_bt") {
          setCDError(true);
          setCDErrorMessage(FILE_SIZE_ERROR);
        } else if (selectID === "drop_rsd_bt") {
          setRSDError(true);
          setRSDErrorMessage(FILE_SIZE_ERROR);
        }
      } else {
        console.log("Error: File not supported");
        if (selectID === "drop_lsd_bt") {
          setLSDError(true);
          setLSDErrorMessage(FILE_TYPE_ERROR);
        } else if (selectID === "drop_cd_bt") {
          setCDError(true);
          setCDErrorMessage(FILE_TYPE_ERROR);
        } else if (selectID === "drop_rsd_bt") {
          setRSDError(true);
          setRSDErrorMessage(FILE_TYPE_ERROR);
        }
      }
    }
  };
  function dragOverHandler(ev) {
    console.log("File(s) in drop zone");
    ev.preventDefault();
  }
  function lsdDropHandler(ev) {
    ev.preventDefault();
    if (ev.dataTransfer.items[0].kind === "file") {
      let image = new Image();
      const selected = ev.dataTransfer.items[0].getAsFile();
      let selectedFile = ev.dataTransfer.items[0].getAsFile();
      setLSDError(false);
      let selectedFileSize = selected.size / 1024 / 1024; // in MB

      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      if (selected && ALLOWED_TYPES.includes(selected.type)) {
        console.log("Selected");
        if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
          setLSDError(true);
          setLSDErrorMessage(FILE_SIZE_ERROR);
          return;
        }
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            setImgLSDPreview(reader.result);
            selectedFile.imageLabel = "Damage - Left Angle";
            selectedFile.additionalDescription = "Damage - Left Angle";
            selectedFile.imageDisplayFileName = selected.name;
            setImgLSDPreviewName(selected.name);
            props.updatePhotoFile(selectedFile);
          };
        };
        reader.readAsDataURL(selected);
      } else {
        setLSDError(true);
        setLSDErrorMessage(FILE_TYPE_ERROR);
      }
    }
  }

  function cdDropHandler(ev) {
    ev.preventDefault();
    if (ev.dataTransfer.items[0].kind === "file") {
      let image = new Image();
      const selected = ev.dataTransfer.items[0].getAsFile();
      let selectedFile = ev.dataTransfer.items[0].getAsFile();
      let selectedFileSize = selected.size / 1024 / 1024; // in MB
      setCDError(false);

      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      if (selected && ALLOWED_TYPES.includes(selected.type)) {
        console.log("Selected");
        if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
          setCDError(true);
          setCDErrorMessage(FILE_TYPE_ERROR);
          return;
        }
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            setImgCDPreview(reader.result);
            selectedFile.imageLabel = "Damage - Center";
            selectedFile.additionalDescription = "Damage - Center";
            selectedFile.imageDisplayFileName = selected.name;
            setImgCDPreviewName(selected.name);
            props.updatePhotoFile(selectedFile);
          };
        };
        reader.readAsDataURL(selected);
      } else {
        setCDError(true);
        setCDErrorMessage(FILE_TYPE_ERROR);
      }
    }
  }

  function rsdDropHandler(ev) {
    ev.preventDefault();
    if (ev.dataTransfer.items[0].kind === "file") {
      let image = new Image();
      const selected = ev.dataTransfer.items[0].getAsFile();
      let selectedFile = ev.dataTransfer.items[0].getAsFile();
      setRSDError(false);
      let selectedFileSize = selected.size / 1024 / 1024; // in MB
      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      if (selected && ALLOWED_TYPES.includes(selected.type)) {
        console.log("Selected");
        if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
          setRSDError(true);
          setRSDErrorMessage(FILE_TYPE_ERROR);
          return;
        }
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            setImgRSDPreview(reader.result);
            selectedFile.imageLabel = "Damage - Right Angle";
            selectedFile.additionalDescription = "Damage - Right Angle";
            selectedFile.imageDisplayFileName = selected.name;
            setImgRSDPreviewName(selected.name);
            props.updatePhotoFile(selectedFile);
          };
        };
        reader.readAsDataURL(selected);
      } else {
        setRSDError(true);
        setRSDErrorMessage(FILE_TYPE_ERROR);
      }
    }
  }
  function deleteLSDFile() {
    setImgLSDPreview(null);
    props.deleteLSDFile();
  }
  function deleteCDFile() {
    setImgCDPreview(null);
    props.deleteCDFile();
  }
  function deleteRSDFile() {
    setImgRSDPreview(null);
    props.deleteRSDFile();
  }
  function deleteLSDErrorFile() {
    setLSDError(false);
  }
  function deleteCDErrorFile() {
    setCDError(false);
  }
  function deleteRSDErrorFile() {
    setRSDError(false);
  }

  function onLSDFileSelectClick() {
    try {
      let elm = document.getElementById("drop_lsd_bt");
      elm.click();
    } catch {}
  }

  function onCDFileSelectClick() {
    try {
      let elm = document.getElementById("drop_cd_bt");
      elm.click();
    } catch {}
  }

  function onRSDFileSelectClick() {
    try {
      let elm = document.getElementById("drop_rsd_bt");
      elm.click();
    } catch {}
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.photoSelectInfo}>
        <Typography className={classes.photoSelectInfo}>
          Photos of the Damage
        </Typography>
      </Grid>
      <Grid container item xs={12} md={4} className={classes.vehInfoDetails}>
        <Typography className={classes.photoInfoDetails}>
          Left Side of Damage
        </Typography>
        <Grid
          xs={12}
          item
          className={classes.dropZone}
          id="drop_zone"
          data-testid={"drop_zone_left"}
          onDrop={lsdDropHandler}
          onDragOver={dragOverHandler}
          onClick={onLSDFileSelectClick}
        >
          {!lsdError ? (
            !imgLSDPreview ? (
              <Grid className={classes.container}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={3} sm={12}>
                    <input
                      type="file"
                      id="drop_lsd_bt"
                      data-testid={"drop_lsd_bt"}
                      className="fileUpload"
                      style={{ display: "none" }}
                      accept=".jpeg,.jpg"
                      onChange={handleEvent}
                    />
                    <h4>
                      <span
                        className={classes.icon + " icon-damage"}
                        style={{
                          fontSize: "55px",
                        }}
                      ></span>
                    </h4>
                  </Grid>
                  <Grid item xs={9} sm={12}>
                    <label className={classes.regularText}>
                      {"Drag & drop a file here or click to select a file"}
                    </label>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid container>
                <Grid item xs={2} md={5}>
                  <img
                    id="clickImg2"
                    src={imgLSDPreview}
                    className={
                      isMobile
                        ? classes.imagePreviewMobile
                        : classes.imagePreview
                    }
                    alt=""
                  />
                </Grid>
                <Grid item xs={8} md={5} className={classes.imagePrevName}>
                  <Typography className={classes.imageName}>
                    {truncateFileName(imgLSDPreviewName)}
                  </Typography>
                </Grid>
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Button
                    color="default"
                    data-testid={"delete_left"}
                    startIcon={<CloseIcon />}
                    onClick={() => deleteLSDFile()}
                    className={classes.rightButton}
                  />
                </Grid>
              </Grid>
            )
          ) : (
            <Grid
              style={{
                textAlign: "center",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <Grid container>
                <Grid container item xs={11} style={{ padding: "1rem" }}>
                  <Grid item xs={10} md={6} style={{ alignContent: "center" }}>
                    <span
                      className="icon-no-image"
                      style={{
                        fontSize: "45px",
                        color: "#8A0200",
                      }}
                    ></span>
                  </Grid>
                  <Grid item xs={10} md={6}>
                    <label className={classes.errorText}>
                      {lsdErrorMessage}
                      <br />
                      <br /> Please select another photo.
                    </label>
                  </Grid>
                </Grid>

                <Grid container item alignContent="center" xs={1}>
                  <Button
                    color="default"
                    startIcon={<CloseIcon />}
                    onClick={() => deleteLSDErrorFile()}
                    className={classes.rightButton}
                    data-testid={"delete_left_error"}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid item container xs={12} md={4} className={classes.vehInfoDetails}>
        <Typography className={classes.photoInfoDetails}>
          Center of Damage &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Typography>
        <Grid
          xs={12}
          item
          className={classes.dropZone}
          data-testid={"drop_zone_center"}
          id="drop_zone"
          onDrop={cdDropHandler}
          onDragOver={dragOverHandler}
          onClick={onCDFileSelectClick}
        >
          {!cdError ? (
            !imgCDPreview ? (
              <Grid className={classes.container}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={3} sm={12}>
                    <input
                      type="file"
                      id="drop_cd_bt"
                      data-testid={"drop_cd_bt"}
                      className="fileUpload"
                      style={{ display: "none" }}
                      accept=".jpeg,.jpg"
                      onChange={handleEvent}
                    />
                    <h4>
                      <span
                        className={classes.icon + " icon-damage"}
                        style={{
                          fontSize: "55px",
                        }}
                      ></span>
                    </h4>
                  </Grid>
                  <Grid item xs={9} sm={12}>
                    <label className={classes.regularText}>
                      {"Drag & drop a file here or click to select a file"}
                    </label>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid container>
                <Grid item xs={2} md={5}>
                  <img
                    id="clickImg2"
                    src={imgCDPreview}
                    className={
                      isMobile
                        ? classes.imagePreviewMobile
                        : classes.imagePreview
                    }
                    alt=""
                  />
                </Grid>
                <Grid item xs={8} md={5} className={classes.imagePrevName}>
                  <Typography className={classes.imageName}>
                    {truncateFileName(imgCDPreviewName)}
                  </Typography>
                </Grid>
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Button
                    color="default"
                    data-testid={"delete_center"}
                    startIcon={<CloseIcon />}
                    onClick={() => deleteCDFile()}
                    className={classes.rightButton}
                  />
                </Grid>
              </Grid>
            )
          ) : (
            <Grid
              style={{
                textAlign: "center",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <Grid container>
                <Grid container item xs={11} style={{ padding: "1rem" }}>
                  <Grid item xs={10} md={6} style={{ alignContent: "center" }}>
                    <span
                      className="icon-no-image"
                      style={{
                        fontSize: "45px",
                        color: "#8A0200",
                      }}
                    ></span>
                  </Grid>
                  <Grid item xs={10} md={6}>
                    <label className={classes.errorText}>
                      {cdErrorMessage}
                      <br />
                      <br /> Please select another photo.
                    </label>
                  </Grid>
                </Grid>

                <Grid container item alignContent="center" xs={1}>
                  <Button
                    color="default"
                    startIcon={<CloseIcon />}
                    onClick={() => deleteCDErrorFile()}
                    className={classes.rightButton}
                    data-testid={"delete_center_error"}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item container xs={12} md={4} className={classes.vehInfoDetails}>
        <Typography className={classes.photoInfoDetails}>
          Right Side of Damage
        </Typography>
        <Grid
          xs={12}
          item
          className={classes.dropZone}
          data-testid={"drop_zone_right"}
          id="drop_zone"
          onDrop={rsdDropHandler}
          onDragOver={dragOverHandler}
          onClick={onRSDFileSelectClick}
        >
          {!rsdError ? (
            !imgRSDPreview ? (
              <Grid className={classes.container}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={3} sm={12}>
                    <input
                      type="file"
                      id="drop_rsd_bt"
                      data-testid={"drop_rsd_bt"}
                      className="fileUpload"
                      style={{ display: "none" }}
                      accept=".jpeg,.jpg"
                      onChange={handleEvent}
                    />
                    <h4>
                      <span
                        className={classes.icon + " icon-damage"}
                        style={{
                          fontSize: "55px",
                        }}
                      ></span>
                    </h4>
                  </Grid>
                  <Grid item xs={9} sm={12}>
                    <label className={classes.regularText}>
                      {"Drag & drop a file here or click to select a file"}
                    </label>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid container>
                <Grid item xs={2} md={5}>
                  <img
                    id="clickImg2"
                    src={imgRSDPreview}
                    className={
                      isMobile
                        ? classes.imagePreviewMobile
                        : classes.imagePreview
                    }
                    alt=""
                  />
                </Grid>
                <Grid item xs={8} md={5} className={classes.imagePrevName}>
                  <Typography className={classes.imageName}>
                    {truncateFileName(imgRSDPreviewName)}
                  </Typography>
                </Grid>
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Button
                    color="default"
                    data-testid={"delete_right"}
                    startIcon={<CloseIcon />}
                    onClick={() => deleteRSDFile()}
                    className={classes.rightButton}
                  />
                </Grid>
              </Grid>
            )
          ) : (
            <Grid
              style={{
                textAlign: "center",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <Grid container>
                <Grid container item xs={11} style={{ padding: "1rem" }}>
                  <Grid item xs={10} md={6} style={{ alignContent: "center" }}>
                    <span
                      className="icon-no-image"
                      style={{
                        fontSize: "45px",
                        color: "#8A0200",
                      }}
                    ></span>
                  </Grid>
                  <Grid item xs={10} md={6}>
                    <label className={classes.errorText}>
                      {rsdErrorMessage}
                      <br />
                      <br /> Please select another photo.
                    </label>
                  </Grid>
                </Grid>

                <Grid container item alignContent="center" xs={1}>
                  <Button
                    color="default"
                    startIcon={<CloseIcon />}
                    onClick={() => deleteRSDErrorFile()}
                    className={classes.rightButton}
                    data-testid={"delete_right_error"}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Damages;
